import Base from 'app/views/base';

import tmpl from './template';

export const REMOVE_TYPES = {
  BTN: 'btn',
  LINK: 'link',
};

export default Base.extend({
  compiledTemplate: tmpl,
  modelProperty: 'color',

  events: {
    'click .remove-field': 'removeField',
  },

  initialize({ property, type = REMOVE_TYPES.BTN, text }) {
    this.property = property;
    this.type = type;
    this.text = text;
  },

  context() {
    return {
      type: this.type,
      text: this.text,
    };
  },

  removeField(e) {
    e.preventDefault();
    this.model.set({ [this.property]: null });
  },
});



// WEBPACK FOOTER //
// ./app/components/pages/brand/remove_property/index.js